/**
 * Bulk Quote Manager
 * Depends on FoxTheme.utils and FoxTheme.pubsub
 */

/* ============================================================
 * TOAST INITIALIZATION
 * ============================================================ */


/* ============================================================
 * POST-SUBMIT CLEANUP (REQUEST QUOTE FORM)
 * ============================================================ */
function removeFromSubmissionMessage(){
  const form = document.querySelector(
    'form[is-request-quote-form="true"]'
  );
  if (!form) return;

  form
    .querySelectorAll('.form-status-list')
    .forEach((el) => el.remove());
}

function checkIfFormSubmitted(){
  const form = document.querySelector(
    'form[is-request-quote-form="true"]'
  );
  if (!form){
    return false;
  }

  const params = new URLSearchParams(window.location.search);
  const isPosted = params.get('contact_posted') === 'true';

  if (!isPosted){
    return false;
  }
  return true;
}

function initBulkQuoteToast() {
  if (document.getElementById('bulk-quote-toast')) return;

  const toast = document.createElement('div');
  toast.id = 'bulk-quote-toast';
  toast.className = 'bulk-quote-toast';
  toast.hidden = true;

  const message = document.createElement('span');
  message.className = 'bulk-quote-toast__message';

  toast.appendChild(message);
  document.body.appendChild(toast);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBulkQuoteToast);
} else {
  initBulkQuoteToast();
}

const BulkQuoteToast = (() => {
  let timeout;

  const getEls = () => ({
    el: document.getElementById('bulk-quote-toast'),
    messageEl: document.querySelector(
      '#bulk-quote-toast .bulk-quote-toast__message'
    ),
  });

  const show = (message, type = 'info', duration = 1600) => {
    const { el, messageEl } = getEls();
    if (!el || !messageEl) return;

    clearTimeout(timeout);

    el.className = `bulk-quote-toast ${type}`;
    messageEl.textContent = message;
    el.hidden = false;

    requestAnimationFrame(() => el.classList.add('show'));

    timeout = setTimeout(() => {
      el.classList.remove('show');
      setTimeout(() => (el.hidden = true), 200);
    }, duration);
  };

  return { show };
})();

/* ============================================================
 * CONFIG
 * ============================================================ */

const BULK_QUOTE_DEFAULTS = {
  maxProducts: 10,
  alertMessage: 'You can only add a limited number of products for bulk quote.',
};

const bulkQuoteConfig = {
  maxProducts:
    FoxTheme?.bulkQuote?.maxProducts || BULK_QUOTE_DEFAULTS.maxProducts,
  alertMessage:
    FoxTheme?.bulkQuote?.alertMessage || BULK_QUOTE_DEFAULTS.alertMessage,
};

/* ============================================================
 * STORAGE UTILS
 * ============================================================ */

class BulkQuoteUtils {
  static storageKey = 'hypertheme:bulk-quote-products';

  static getSelectedProducts() {
    return FoxTheme.utils.getStorage(this.storageKey) || [];
  }

  static setSelectedProducts(products) {
    products.length
      ? FoxTheme.utils.setStorage(this.storageKey, products)
      : localStorage.removeItem(this.storageKey);
  }

  static isProductInList(productId) {
    return this.getSelectedProducts().some(
      (p) => String(p.id) === String(productId)
    );
  }

  static addToList(productId, productUrl) {
    const products = this.getSelectedProducts();

    if (products.length >= bulkQuoteConfig.maxProducts) {
      FoxTheme.pubsub.publish('bulk-quote:error', {
        message: bulkQuoteConfig.alertMessage,
      });
      return false;
    }

    const exists = products.find(
      (p) => String(p.id) === String(productId)
    );

    if (!exists) {
      products.push({
        id: productId,
        url: productUrl,
        qty: 1,
      });
    }

    this.setSelectedProducts(products);

    FoxTheme.pubsub.publish('bulk-quote:add', {
      products,
      productId,
    });

    return true;
  }

  static updateQty(productId, qty) {
    const products = this.getSelectedProducts();
    const item = products.find(
      (p) => String(p.id) === String(productId)
    );

    if (!item) return;

    item.qty = Math.max(1, qty);
    this.setSelectedProducts(products);

    FoxTheme.pubsub.publish('bulk-quote:update', {
      products,
      productId,
      qty: item.qty,
    });
  }

  static removeFromList(productId) {
    const products = this.getSelectedProducts().filter(
      (p) => String(p.id) !== String(productId)
    );

    this.setSelectedProducts(products);

    FoxTheme.pubsub.publish('bulk-quote:remove', {
      products,
      productId,
    });
  }
}


function handleRequestQuotePostSubmit() {
  if(checkIfFormSubmitted()){
    const params = new URLSearchParams(window.location.search);
    BulkQuoteUtils.setSelectedProducts([]);

    updateRequestQuoteButtons();
    syncQuoteQuantities();
    syncQuoteForm();

    params.delete('contact_posted');

    const newUrl =
      window.location.pathname +
      (params.toString() ? `?${params.toString()}` : '');

    window.history.replaceState({}, document.title, newUrl);
  }
};


/* ============================================================
 * REQUEST A QUOTE BUTTON STATE
 * ============================================================ */

function updateRequestQuoteButtons() {
  const buttons = document.querySelectorAll('[data-ele="request-a-quote"]');
  const selectedIds = new Set(
    BulkQuoteUtils.getSelectedProducts().map((p) => String(p.id))
  );

  buttons.forEach((btn) => {
    const productId = btn.dataset.productId;
    const redirectDisable = btn.dataset.redirectDisable;
    if (!productId) return;

    const isAdded = selectedIds.has(String(productId));
    const text = btn.querySelector('.btn__text');

    if (isAdded) {
      if(redirectDisable === 'true'){
        btn.classList.add('is-disabled');
        btn.setAttribute('aria-disabled', 'true');
      }
      //if (text) text.textContent = 'Already added';
    } else {
      btn.classList.remove('is-disabled');
      btn.removeAttribute('aria-disabled');
      //if (text) text.textContent = 'Request a Quote';
    }
  });
}

/* ============================================================
 * QUANTITY SYNC (STORAGE → UI)
 * ============================================================ */

function syncQuoteQuantities() {
  BulkQuoteUtils.getSelectedProducts().forEach(({ id, qty }) => {
    const item = document.querySelector(
      `.compare-bar__item[data-product-id="${id}"]`
    );

    if (!item) return;

    const input = item.querySelector('.quantity__input');
    const minus = item.querySelector('.quantity__button[name="minus"]');

    if (input) input.value = Math.max(1, qty);
    if (minus) minus.disabled = qty <= 1;
  });
}

/* ============================================================
 * QUANTITY HANDLERS (PLUS / MINUS / INPUT)
 * ============================================================ */

if (!window.__BULK_QUOTE_QTY_BOUND__) {
  window.__BULK_QUOTE_QTY_BOUND__ = true;

  document.addEventListener(
    'click',
    (event) => {
      const btn = event.target.closest(
        '.quantity__button[name="plus"], .quantity__button[name="minus"]'
      );
      if (!btn) return;

      const item = btn.closest('.compare-bar__item');
      if (!item) return;

      const input = item.querySelector('.quantity__input');
      const productId = item.dataset.productId;
      if (!input || !productId) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      let qty = Number(input.value || 1);

      if (btn.name === 'plus') qty += 1;
      if (btn.name === 'minus') qty -= 1;

      qty = Math.max(1, qty);

      // Update storage (single source of truth)
      BulkQuoteUtils.updateQty(productId, qty);

      // Reflect immediately in UI
      input.value = qty;

      // Disable minus at qty = 1
      const minusBtn = item.querySelector(
        '.quantity__button[name="minus"]'
      );
      if (minusBtn) minusBtn.disabled = qty === 1;
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target.closest('.quantity__input');
      if (!input) return;

      const item = input.closest('.compare-bar__item');
      if (!item) return;

      const productId = item.dataset.productId;
      if (!productId) return;

      let qty = Math.max(1, Number(input.value || 1));

      BulkQuoteUtils.updateQty(productId, qty);
      input.value = qty;

      const minusBtn = item.querySelector(
        '.quantity__button[name="minus"]'
      );
      if (minusBtn) minusBtn.disabled = qty === 1;
    },
    true
  );
}



/* ============================================================
 * BULK QUOTE LIST COMPONENT
 * ============================================================ */

class BulkQuoteList extends HTMLElement {
  connectedCallback() {
    this.container = this.querySelector('[data-ele="bulk-quote-list-items"]');
    if (!this.container) return;

    this.render();

    this.addUnsub = FoxTheme.pubsub.subscribe(
      'bulk-quote:add',
      () => this.render()
    );
    this.removeUnsub = FoxTheme.pubsub.subscribe(
      'bulk-quote:remove',
      () => this.render()
    );

    this.addEventListener('click', this.onRemoveClick.bind(this));
  }

  onRemoveClick(event) {
    const btn = event.target.closest(
      'button[is="compare-remove"], .compare-bar__item-remove'
    );
    if (!btn) return;

    event.preventDefault();
    BulkQuoteUtils.removeFromList(btn.dataset.productId);
  }

  async render() {
    if(checkIfFormSubmitted()){
      return true
    }
    const products = BulkQuoteUtils.getSelectedProducts();
    const tmps = {};

    await Promise.all(
      products.map(async (p) => {
        try {
          const res = await fetch(
            `${p.url}?sections=product-request-quote`
          );
          const json = await res.json();

          const doc = new DOMParser().parseFromString(
            json['product-request-quote'],
            'text/html'
          );

          const section = doc.querySelector('.shopify-section');
          if (!section) {
            tmps[p.id] = '';
            return;
          }

          const item = section.querySelector(
            `.compare-bar__item[data-product-id="${p.id}"]`
          );

          if (item) {
            tmps[p.id] = section.innerHTML;
          } else {
            tmps[p.id] = '';
            BulkQuoteUtils.removeFromList(p.id);
          }
        } catch (err) {
          console.error('quote render error', err);
          tmps[p.id] = '';
        }
      })
    );


    this.container.innerHTML = products.map((p) => tmps[p.id]).join('');
    syncQuoteQuantities();

    if (typeof syncQuoteForm === 'function') {
      syncQuoteForm();
    }
  }
}



customElements.define('bulk-quote-list', BulkQuoteList);

/* ============================================================
 * REQUEST A QUOTE CLICK HANDLER
 * ============================================================ */

document.addEventListener(
  'click',
  (event) => {
    const btn = event.target.closest('[data-ele="request-a-quote"]');
    if (!btn) return;
    const redirectDisable = btn.dataset.redirectDisable;

    event.preventDefault();

    const { productId, productUrl } = btn.dataset;
    if (!productId || !productUrl) return;

    if (BulkQuoteUtils.isProductInList(productId)) {
      BulkQuoteToast.show('Already added to quote', 'info');
      if(redirectDisable !== 'true'){
        window.location.href = btn.href;
      }
      return;
    }

    if (!BulkQuoteUtils.addToList(productId, productUrl)) return;

    
    if(redirectDisable === 'true'){
      BulkQuoteToast.show('Added to quote', 'success');
    }else{
      BulkQuoteToast.show('Added to quote. Redirecting…', 'success');
      window.location.href = btn.href;
    }
  },
  true
);


/* ============================================================
 * REQUEST QUOTE FORM SYNC
 * ============================================================ */

/**
 * Syncs quote items into contact form as hidden inputs.
 * Runs only for forms marked with is-request-quote-form="true".
 */
function syncQuoteForm() {
  const form = document.querySelector(
    'form[is-request-quote-form="true"]'
  );

  if (!form) return;

  // Remove previously injected quote inputs
  form
    .querySelectorAll('[data-bulk-quote-field]')
    .forEach((el) => el.remove());

  const products = BulkQuoteUtils.getSelectedProducts();
  if (!products.length) return;

  products.forEach((item, index) => {
    const { id, qty = 1 } = item;

    // Find title from rendered quote item
    const domItem = document.querySelector(
      `.compare-bar__item[data-product-id="${id}"]`
    );

    const title =
      domItem?.dataset.title || `Product ${id}`;

    // Product title input
    const titleInput = document.createElement('input');
    titleInput.type = 'hidden';
    titleInput.name = `contact[${title}]`;
    titleInput.value = qty;
    titleInput.dataset.bulkQuoteField = 'true';

    // Quantity input
    // const qtyInput = document.createElement('input');
    // qtyInput.type = 'hidden';
    // qtyInput.name = `contact[Products][${index}][qty]`;
    // qtyInput.value = qty;
    // qtyInput.dataset.bulkQuoteField = 'true';

    form.appendChild(titleInput);
    //form.appendChild(qtyInput);
  });
}

/* ============================================================
 * PUBSUB SIDE EFFECTS (SINGLE PLACE)
 * ============================================================ */

FoxTheme.pubsub.subscribe('bulk-quote:add', () => {
  updateRequestQuoteButtons();
  syncQuoteQuantities();
  syncQuoteForm();
  removeFromSubmissionMessage();
});

FoxTheme.pubsub.subscribe('bulk-quote:remove', () => {
  updateRequestQuoteButtons();
  syncQuoteQuantities();
  syncQuoteForm();
});

FoxTheme.pubsub.subscribe('bulk-quote:update', () => {
  syncQuoteQuantities();
  syncQuoteForm();
});

FoxTheme.pubsub.subscribe('bulk-quote:error', ({ message }) => {
  BulkQuoteToast.show(message, 'error');
});

/* ============================================================
 * SHOPIFY SECTION EVENTS
 * ============================================================ */

document.addEventListener('shopify:section:load', () => {
  updateRequestQuoteButtons();
  syncQuoteQuantities();
  syncQuoteForm();
});

document.addEventListener('shopify:section:select', () => {
  updateRequestQuoteButtons();
  syncQuoteQuantities();
  syncQuoteForm();
});

/* ---------------------------------------------
 * Variant Weight Listener
 * ------------------------------------------- */

FoxTheme.pubsub.subscribe(
  FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
  (payload) => {
    if (!payload || !payload.data) return;

    const { variant, sectionId } = payload.data;
    if (!variant || !sectionId) return;

    const productSection = document.querySelector(
      `[data-section="${sectionId}"]`
    );
    if (!productSection) return;

    const form = productSection.querySelector(
      '[data-type="add-to-cart-form"]'
    );
    if (!form) return;

    const ele = form.querySelector('[data-ele="request-a-quote"]');
    const maxAllowedWeight = ele
      ? Number(ele.dataset.weight || 0)
      : 0;

    const weightKg = Number(variant.weight || 0) / 1000;

    form.dataset.requestAQuote =
      weightKg > maxAllowedWeight ? 'true' : 'false';
  }
);



/* ============================================================
 * DOCUMENT READY (SAFE INIT)
 * ============================================================ */

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    handleRequestQuotePostSubmit()
    updateRequestQuoteButtons();
    syncQuoteQuantities();
    syncQuoteForm();
  });
} else {
  handleRequestQuotePostSubmit()
  updateRequestQuoteButtons();
  syncQuoteQuantities();
  syncQuoteForm();
}

document.addEventListener('shopify:section:load', () => {
  updateRequestQuoteButtons();
  syncQuoteQuantities();
});

(function observeDynamicDom() {
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;

        if (
          node.matches?.('[data-ele="request-a-quote"]') ||
          node.querySelector?.('[data-ele="request-a-quote"]')
        ) {
          updateRequestQuoteButtons();
          syncQuoteQuantities();
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
